import React from 'react';
import Header from '../components/Header';
import Multiservicos from '../components/Multiservicos';
import Footer from '../components/Footer';

const MultiservicosPage = () => {
  return (
    <div className="App">
      <Header />
      <main><Multiservicos /></main>
      <Footer />
    </div>
  );
};

export default MultiservicosPage;
